import { MapLocationSelectionCmp } from '@porterin/component-library/src/location-accuracy/components/MapLocationSelectionCmp';
import { SelectLocationControllerCmp } from '@porterin/component-library/src/location-accuracy/components/SelectLocationControllerCmp';
import { useLocation } from '@porterin/component-library/src/location-accuracy/contexts/LocationContext';
import React from 'react';

export interface LocationAccuracyProps {
  close_modal: () => void;
}

export const LocationAccuracyCmp: React.FC<LocationAccuracyProps> = ({
  close_modal,
}) => {
  const { state } = useLocation();

  return state.step === 'SelectLocation' ? (
    <div
      data-testid="select-location-wrapper"
      className="w-full h-[100vh] md:h-auto max-md:overflow-y-scroll box-border bg-white md:p-[3.2rem] z-[200] relative"
    >
      <SelectLocationControllerCmp close_modal={close_modal} />
    </div>
  ) : state.step === 'LocationAccuracy' ? (
    <div
      data-testid="map-location-wrapper"
      className="w-full h-[100vh] md:h-auto max-md:overflow-y-scroll box-border bg-white md:p-[3.2rem] z-[200] relative"
    >
      <MapLocationSelectionCmp />
    </div>
  ) : null;
};
